var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editorTool"},[(_vm.isShowStep)?_c('Step',{attrs:{"step-index":_vm.stepIndex}}):_vm._e(),_c('Tips',{attrs:{"content":_vm.content}}),(_vm.pedestalId)?_c('Pedesta',{attrs:{"template-show-data":_vm.TmpData,"pedestal-id":_vm.pedestalId},on:{"getPedestaData":_vm.getPedestaData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }